export default {
  '@am': 'Areas.ApplicationMaps',
  '@frs': 'Areas.FieldRecordSystem',
  '@realestate': 'Areas.RealEstate',
  '@pm': 'Areas.PoultryManagement',
  '@ms': 'Areas.MaizeSowing',
  '@sam': 'Areas.SimpleApplicationMaps',
  '@em': 'Areas.EntityManagement'
}
